<p-card *ngIf="jurisdicaoLocal">
  <ng-template pTemplate="header">
    <div class="title-visualizacao"><span class="cl-blue"> Jurisdição local: </span>
      <span>{{jurisdicaoLocal?.descricao}}</span>
    </div>
  </ng-template>
  <div class="p-fluid">
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Id:</label>
      <div class="p-col-12 p-md-10">{{jurisdicaoLocal.id}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Origem Id:</label>
      <div class="p-col-12 p-md-10">{{jurisdicaoLocal.origemId}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Descrição:</label>
      <div class="p-col-12 p-md-10">{{jurisdicaoLocal.descricao}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Situação: </label>
      <div class="p-col-12 p-md-10" *ngIf="jurisdicaoLocal?.situacao === 'ATIVO'" class="badge badge-success m-l-8">Ativo</div>
      <div class="p-col-12 p-md-10" *ngIf="jurisdicaoLocal?.situacao === 'INATIVO'" class="badge badge-danger m-l-8">Inativo</div>
    </div>

    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Regiões:</label>
      <div class="p-col-12 p-md-12">
        <div class="subtitle-visualizacao" *ngIf="jurisdicaoLocal.regioes">
          <br>
          <p-table
            [value]="jurisdicaoLocal.regioes"
            responsive="true"
            responsiveLayout="scroll"
            styleClass="p-datatable-striped">
            <ng-template pTemplate="header">
              <tr>
                <th>Id</th>
                <th>Origem Id</th>
                <th>Abrangência</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr>
                <td>{{ item.id }}</td>
                <td>{{ item.origemId }}</td>
                <td>
                  <div *ngIf="item.abrangencia">
                    <ng-container [ngSwitch]="item.abrangencia">
                      <a *ngSwitchCase="'LOCALIDADE'" [routerLink]="['/localidade/visualizar', item.localidade?.id]">
                        {{ item.localidade?.nome }} - {{ item.localidade?.unidadeFederativa?.sigla }}
                      </a>
                      <a *ngSwitchCase="'ESTADUAL'" [routerLink]="['/unidadeFederativa/visualizar', item?.unidadeFederativa?.id]">
                        {{ item.unidadeFederativa?.nome }} - {{ item.unidadeFederativa.sigla }}
                      </a>
                      <span *ngSwitchCase="'NACIONAL'">Nacional</span>
                    </ng-container>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="3">Nenhuma região cadastrada.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6">
        <button pButton appBotaoVoltar  label="Voltar"></button>
      </div>
      <div class="p-field p-col-6">
        <button pButton  class="p-primary" label="Sincronizar"
           (click)="sincronizarPorId()"></button>
      </div>
    </div>
  </ng-template>
</p-card>
